// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinGameForm_container__1XHBq"};